import React from "react";
import SmartComponent from "../SmartComponent";
import FrameListButton from "./FrameListButton";

export class FrameListSelector extends SmartComponent {
  render() {
    if (this.props.frameList.list.length > 1) {
      return (
        <div className="frame-list-selector-group selector-group">
          {this.props.frameList.list.map(
            frameList => (
              <FrameListButton
                key={frameList.id} // Required for arrays of objects like this
                frameList={frameList}
                isSelected={this.props.frameList.active.id === frameList.id}
                panelId={this.props.panelId}
                isNow={this.props.frameList.current.id === frameList.id}
              />
            ),
            this
          )}
        </div>
      );
    } else {
      return "";
    }
  }
}

export default FrameListSelector;
